import TOGGLE_SIDEBAR from './actionTypes';
import initialState from './initialState';

const sessionReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case TOGGLE_SIDEBAR:
      return {
        ...state,
        isOpen: !state.isOpen,
      };
    default:
      return state;
  }
};

export default sessionReducer;
